import axios from "axios";
import { verifiedIniciadorBaseUrl } from "../../constants";

export const iniciadorActiveBanks = async () => {
  if (verifiedIniciadorBaseUrl) {
    return await axios({
      method: "GET",
      url: verifiedIniciadorBaseUrl,
    })
      .then((res) => {
        if (res.data?.body?.participants) {
          return res.data?.body?.participants;
        } else {
          return [];
        }
      })
      .catch(async (err) => {
        console.error(
          "iniciador get active banks failed with error: ",
          err?.message,
        );
        return [];
      });
  } else {
    return [];
  }
};

export const iniciadorLinkDetails = async (linkId) => {
  if (verifiedIniciadorBaseUrl) {
    return await axios({
      method: "GET",
      url: `${verifiedIniciadorBaseUrl}/connect-link?link_id=${linkId}`,
    })
      .then((res) => {
        if (res.data?.body?.data) {
          return res.data?.body?.data;
        } else {
          return [];
        }
      })
      .catch(async (err) => {
        console.error(
          "iniciador get link details failed with error: ",
          err?.message,
        );
        return [];
      });
  } else {
    return [];
  }
};

export const iniciadorConnectLink = async (userId, participantId) => {
  if (verifiedIniciadorBaseUrl) {
    return await axios({
      method: "POST",
      url: `${verifiedIniciadorBaseUrl}/connect-link`,
      data: {
        user_id: userId,
        participant_id: participantId,
      },
    })
      .then((res) => {
        if (res?.data?.body?.data?.consentRedirectURL) {
          return {
            link: res?.data?.body?.data?.consentRedirectURL,
            id: res?.data?.body?.data?.accessTokenId,
          };
        } else {
          return null;
        }
      })
      .catch(async (err) => {
        console.error(
          "iniciador get connect link failed with error: ",
          err?.message,
        );
        return null;
      });
  } else {
    return null;
  }
};

export const iniciadorUserAccounts = async (userId) => {
  if (verifiedIniciadorBaseUrl) {
    return await axios({
      method: "GET",
      url: `${verifiedIniciadorBaseUrl}/user-accounts?user_id=${userId}`,
    })
      .then((res) => {
        if (res?.data?.body?.accounts) {
          return res?.data?.body?.accounts;
        } else {
          return null;
        }
      })
      .catch(async (err) => {
        console.error(
          "iniciador get user accounts failed with error: ",
          err?.message,
        );
        return null;
      });
  } else {
    return null;
  }
};

export const iniciadorRevokeLink = async (userId) => {
  if (verifiedIniciadorBaseUrl) {
    return await axios({
      method: "POST",
      url: `${verifiedIniciadorBaseUrl}/delete-link`,
      data: {
        user_id: userId,
      },
    })
      .then((res) => {
        if (res?.data?.body?.revoked) {
          return true;
        } else {
          return false;
        }
      })
      .catch(async (err) => {
        console.error("iniciador revove permission failed with error: ", err);
        return false;
      });
  } else {
    return false;
  }
};

export const iniciadorUserBankFixedIncome = async (userId) => {
  if (verifiedIniciadorBaseUrl) {
    return await axios({
      method: "GET",
      url: `${verifiedIniciadorBaseUrl}/bank-fixed-income?user_id=${userId}`,
    })
      .then((res) => {
        if (res?.data?.body?.data) {
          return res?.data?.body?.data;
        } else {
          return null;
        }
      })
      .catch(async (err) => {
        console.error(
          "iniciador get user bank fixed income failed with error: ",
          err?.message,
        );
        return null;
      });
  } else {
    return null;
  }
};

export const iniciadorUserCreditFixedIncome = async (userId) => {
  if (verifiedIniciadorBaseUrl) {
    return await axios({
      method: "GET",
      url: `${verifiedIniciadorBaseUrl}/credit-fixed-income?user_id=${userId}`,
    })
      .then((res) => {
        if (res?.data?.body?.data) {
          return res?.data?.body?.data;
        } else {
          return null;
        }
      })
      .catch(async (err) => {
        console.error(
          "iniciador get user credit fixed income failed with error: ",
          err?.message,
        );
        return null;
      });
  } else {
    return null;
  }
};

export const iniciadorUserVariableIncome = async (userId) => {
  if (verifiedIniciadorBaseUrl) {
    return await axios({
      method: "GET",
      url: `${verifiedIniciadorBaseUrl}/variable-income?user_id=${userId}`,
    })
      .then((res) => {
        if (res?.data?.body?.data) {
          return res?.data?.body?.data;
        } else {
          return null;
        }
      })
      .catch(async (err) => {
        console.error(
          "iniciador get user variable income failed with error: ",
          err?.message,
        );
        return null;
      });
  } else {
    return null;
  }
};

export const iniciadorUserTreasureTitles = async (userId) => {
  if (verifiedIniciadorBaseUrl) {
    return await axios({
      method: "GET",
      url: `${verifiedIniciadorBaseUrl}/treasure-titles?user_id=${userId}`,
    })
      .then((res) => {
        if (res?.data?.body?.data) {
          return res?.data?.body?.data;
        } else {
          return null;
        }
      })
      .catch(async (err) => {
        console.error(
          "iniciador get user treasure titles failed with error: ",
          err?.message,
        );
        return null;
      });
  } else {
    return null;
  }
};

export const iniciadorUserFunds = async (userId) => {
  if (verifiedIniciadorBaseUrl) {
    return await axios({
      method: "GET",
      url: `${verifiedIniciadorBaseUrl}/funds?user_id=${userId}`,
    })
      .then((res) => {
        if (res?.data?.body?.data) {
          return res?.data?.body?.data;
        } else {
          return null;
        }
      })
      .catch(async (err) => {
        console.error(
          "iniciador get user funds failed with error: ",
          err?.message,
        );
        return null;
      });
  } else {
    return null;
  }
};
